import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f453a7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "order-status fw600" }
const _hoisted_3 = { class: "status-tips" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "copy",
  id: "copyItem"
}, "复制", -1))
const _hoisted_5 = {
  key: 0,
  class: "empty-wrap"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "暂无报价", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "van-hairline--top price-list-wrap"
}
const _hoisted_9 = { class: "price-item-left" }
const _hoisted_10 = { class: "activity" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "package" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "price-item-right" }, null, -1))
const _hoisted_14 = { class: "bill-sum-wrap" }
const _hoisted_15 = { class: "bill-sum" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", null, "暂未开单")
], -1))
const _hoisted_17 = {
  key: 2,
  class: "shrink-wrap"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shrink-title-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "shrink-title" }, "已选服务项目")
], -1))
const _hoisted_19 = { class: "van-hairline--top package-wrap" }
const _hoisted_20 = { class: "package-title" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "material-list-wrap" }
const _hoisted_23 = { class: "name" }
const _hoisted_24 = { class: "price" }
const _hoisted_25 = { class: "name" }
const _hoisted_26 = { class: "price" }
const _hoisted_27 = { class: "van-hairline--top package-wrap" }
const _hoisted_28 = { class: "package-title" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "material-list-wrap" }
const _hoisted_31 = { class: "name" }
const _hoisted_32 = { class: "price" }
const _hoisted_33 = { class: "name" }
const _hoisted_34 = { class: "price" }
const _hoisted_35 = {
  key: 3,
  class: "authwarehouse-message",
  style: {"margin-top":"16px"}
}
const _hoisted_36 = {
  key: 0,
  class: "form-footer xag-page__footer device-replace-button-wrap"
}
const _hoisted_37 = {
  key: 0,
  class: "authwarehouse-message"
}
const _hoisted_38 = { class: "button-wrap xag-flex" }
const _hoisted_39 = {
  key: 1,
  class: "pay-button-wrap"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useAppPay } from '@/compositions/usePay'
import { useClipboard } from '@/compositions/common'
import { Toast, PullRefresh, Button, Dialog } from 'vant'
import { useOrderApply } from '@/compositions/invoice/index'
import { isAuthWarehouse } from '@/defination/malfunction-repair'
import { commonErrorHandle, getErrorMessage } from '@/utils/error-handle'
import { ref, Ref, computed, ComputedRef, onMounted, onDeactivated } from 'vue'
import { useMalfunctionRepairStore } from '@/compositions/malfunction-repair'
import { MalfunctionRepairOrderDetailStorage } from '@/storage/malfunction-repair'
import {
  UpgradeMaintenanceDetail,
  ConfirmPayOrderResult,
  ConfirmPayOrderPrams,
} from '@/types/malfunction-repair'
import {
  showToastLoading,
  showNormalToast,
  showToastSuccess,
  showConfirmModal,
  clearToast,
} from '@/utils/tools'
import { UpdateMaintenanceStatusColorMap } from '@/defination/malfunction-repair'
import {
  confirmOrderRepair,
  confirmPayRepairOrder,
  checkRepairOrderPayStatus,
  getUpgradeMaintenanceDetail,
  submitRepairOrderInvoiceInfo,
} from '@/apis/malfunction-repair'
import wx from 'weixin-js-sdk'
import AppHeader from '@/components/Header.vue'
import BehalfPay from '@/components/pay/behalf-pay.vue'
import { CacheSelectRepairOrderInfoKey } from '@/config/insurance'
import OrderInoviceApply from '@/components/invoice/order-inovice-apply.vue'

type ActivityItem = UpgradeMaintenanceDetail['billInfo']['list'][number]
type PackageItem = ActivityItem['package'][number]


import { defineComponent } from 'vue'
import BlockWrap from './components/block-wrap.vue'
const __default__ = defineComponent({
  name: 'malfunction-upgrade-maintenance-detail',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {
  addUpdateMaintainOrderKeepAlive,
  removeUpdateMaintainOrderKeepAlive,
  removeServiceOrderKeepAlive,
  removeFaultOrderListItemKeepAlive,
} = useMalfunctionRepairStore()
const $router = useRouter()
const $route = useRoute()
const $store = useStore()
const isMiniProgram = computed(() => {
  return $store.getters.isMiniProgram
})
let timeId: number
const guid = $route.query.guid as string
const serviceGuid = $route.query.serviceGuid as string
const refreshing = ref(false)
const behalfPayDialogVisible = ref(false)
const confirmPayInfo: Ref<ConfirmPayOrderResult | null> = ref(null)
const confirmPayParams: Ref<ConfirmPayOrderPrams | null> = ref(null)
const behalfStatusCheckHandle: Ref<() => Promise<boolean> | null> = ref(null)
const authWarehouseMessage = `* 授权网点升级保养业务由客户与网点自行线下结算，当前页面价格为极飞指导价，非最终实际定价。`
const isAuthWarehouseOrder = ref(false)
const {
  invoiceData,
  scrollToInvoiceDom,
  invoiceDomInit,
  changeHandle: invoiceChangeHandle,
  verify: invoiceVerify,
  getOrderInvocieSubmitParams,
} = useOrderApply()
let detail: Ref<null | UpgradeMaintenanceDetail> = ref({
  status: '',
  statusText: '',
  color: '',
  sn: '',
  canInvoice: false,
  billInfo: {
    list: [],
    sum: 0,
  },
  invoiceInfo: {
    guid: '',
    logo: '',
    sn: '',
    modelNum: '',
    productName: '',
    time: '',
    billAmount: 0,
    invoiceAmount: 0,
  },
  invoice_apply: null,
})
const { initClipboard } = useClipboard({
  text: () => detail.value?.sn,
})
const { compatibleWechatAndCmdPay, judgeCanUseMiniProgramPay } = useAppPay()

const isBillEmpty = computed(() => {
  return ['14', '2', '3', '4', '4-1', '4-2'].includes(detail.value.status)
})

const canConfirmRepair = computed(() => {
  return detail.value.status === '5'
})
const canPay = computed(() => {
  return detail.value.status === '11' && !isAuthWarehouseOrder.value
})
const canInvoice = computed(() => {
  return detail.value.canInvoice
})
// 显示底部按钮
const showFooter: ComputedRef<boolean> = computed(() => {
  return canConfirmRepair.value || canPay.value || canInvoice.value
})

function activityShrinkHandle(item: ActivityItem) {
  item.isShrink = !item.isShrink
}

function packageItemShrinkHandle(item: PackageItem) {
  item.isShrink = !item.isShrink
}
const isShrink = ref(false)
const titleArrowText = computed(() => {
  return isShrink.value ? '展开' : '收起'
})
function shrinkClickHandle() {
  isShrink.value = !isShrink.value
}

function handleSearchOrderPayStatus(pay_order_no: string, immediately = false) {
  // 查询单据支付状态
  let i = 0
  let searching = false
  function handleFn() {
    showToastLoading({
      message: '支付结果查询中',
    })
    if (i >= 12) {
      clearInterval(timeId)
      clearToast()
      Dialog.confirm({
        title: '查询结果失败',
        message: `支付订单号${pay_order_no}，请尝试继续校验，如需帮助请联系客服：400-780-3131`,
        confirmButtonText: '重新查询',
        cancelButtonText: '取消查询',
        className: 'reserve-dialog',
        width: 304,
      })
        .then(async () => {
          try {
            handleSearchOrderPayStatus(pay_order_no, true)
          } catch (error: any) {
            Dialog.close()
          }
        })
        .catch(() => {
          Dialog.close()
        })
    }
    if (searching) {
      return
    }
    searching = true
    checkRepairOrderPayStatus(guid)
      .then((result) => {
        if (result) {
          clearToast()
          // 跳转到支付成功页面
          clearInterval(timeId)
          showToastSuccess('支付成功')
          removeServiceOrderKeepAlive()
          removeFaultOrderListItemKeepAlive()
          setTimeout(() => {
            $router.go(-1)
          }, 500)
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
      .finally(() => {
        searching = false
        i++
      })
  }
  if (immediately) {
    handleFn()
  }
  //
  timeId = setInterval(async () => {
    // 如果查询时间超过1分钟 那么停止查询并提示
    handleFn()
  }, 5000)
}
// 支付成功页面
const getCbPageUrl = (): string => {
  return `/malfunction-repair/pay-success/${detail?.value.sn}/${serviceGuid}/${detail.value.billInfo.sum}/upgradeMainTenance`
}
async function getPayInfoHandle() {
  // 获取支付相关信息
  const canUseCmbPay = await judgeCanUseMiniProgramPay()
  try {
    const params = {
      guid,
      from: isMiniProgram.value ? 'applets' : 'app',
      payment_platform: canUseCmbPay ? 'merchants_bank' : 'wechat',
      callback_page_url: window.location.origin + getCbPageUrl(),
    }
    showToastLoading()
    const result = await confirmPayRepairOrder(params)
    clearToast()
    confirmPayInfo.value = result
    confirmPayParams.value = params
  } catch (error) {
    // 如果获取支付信息失败就刷新页面即可
    initPageDetail()
    return Promise.reject(error)
  }
}
function payInfoHandle(mode = 'half') {
  const isBehalf = mode === 'behalf'
  const isHalf = mode === 'half'
  const result = confirmPayInfo.value
  const params = confirmPayParams.value
  if (!result.need_wechat_pay) {
    initPageDetail()
    return
  }
  if (result.pay_type == '线上支付') {
    if (isHalf) {
      // 自己支付时
      halfPayHandle()
    } else if (isBehalf) {
      behalfPayHandle()
    }
    return
  }
  if (result.pay_type == '线下支付') {
    if (result.need_wechat_pay) {
      Toast('错误，线下支付不需要微信支付！')
    } else {
      initPageDetail()
    }
  }
  removeServiceOrderKeepAlive()
}
async function halfPayHandle() {
  const result = confirmPayInfo.value
  const params = confirmPayParams.value
  if (params.from === 'applets') {
    // 小程序支付
    wx.miniProgram.navigateTo({
      url: '/pages/user/pay?guid=' + result.pay_order_no,
    })
  } else {
    //appHost.onPay(result.pay_order_no)
    const userAgree = await compatibleWechatAndCmdPay(result.pay_order_no)
    userAgree && handleSearchOrderPayStatus(result.pay_order_no)
  }
}
function behalfPaySuccessHandle() {
  if (!behalfPayDialogVisible.value) {
    // 如果用户是已经关闭了代付弹窗的状态，不给用户支付成功响应
    return
  }
  behalfPayDialogVisible.value = false
  // 代付支付成功回调
  showToastSuccess('支付成功')
  removeServiceOrderKeepAlive()
  removeFaultOrderListItemKeepAlive()
  setTimeout(() => {
    $router.go(-1)
  }, 2000)
}
async function behalfPayHandle() {
  // 他人代付处理逻辑
  behalfPayDialogVisible.value = true
  behalfStatusCheckHandle.value = async () => {
    try {
      const data = await checkRepairOrderPayStatus(guid)
      return data
    } catch (error) {
      return false
    }
  }
}
async function beforePayHandle(mode: string) {
  if (!isAuthWarehouseOrder.value && !invoiceVerify()) {
    return
  }
  try {
    await showConfirmModal({
      title: '提示',
      message: '是否确认支付',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
      cancelButtonText: '取消',
      confirmButtonText: '确定',
    })
  } catch (error) {
    return
  }
  try {
    confirmPayInfo.value ? '' : await getPayInfoHandle()
    payInfoHandle(mode)
  } catch (error) {
    return
  }
  return true
}
// 更新维修单发票信息
async function updateInvoiceInfoHandle(): Promise<void> {
  const params = getOrderInvocieSubmitParams()
  try {
    await submitRepairOrderInvoiceInfo(guid, params)
  } catch (error) {
    console.log('error', error)
    const message = `发票选择失败: ${getErrorMessage(error)}`
    showNormalToast(message)
  }
  return null
}

async function initPageDetail(refresh = false) {
  if (!refresh) {
    showToastLoading()
  }
  if (invoiceData.value && invoiceData.value?.invoice_guid) {
    await updateInvoiceInfoHandle()
  }
  try {
    let detailData = await getUpgradeMaintenanceDetail(guid)
    detail.value.status = detailData.order.status
    detail.value.statusText = detailData.order.status_text
    detail.value.color = UpdateMaintenanceStatusColorMap.get(detailData.order.status) || '#F7981C'
    detail.value.sn = detailData.order.repair_sn
    detail.value.canInvoice = detailData.order.invoice_apply
    if (detailData.pay_info) {
      detail.value.billInfo.sum = detailData.pay_info.pay_amount.toFixed(2)
    }
    detail.value.billInfo.list = (detailData.activities || []).map((activitieItem) => {
      return {
        activity: activitieItem.name,
        package: activitieItem.packages.map((packageItem) => {
          return {
            index: '',
            name: packageItem.name,
            price: packageItem.pay_amount.toFixed(2),
            matrialArr: packageItem.materials.map((matrialArrItem) => {
              return {
                name: matrialArrItem.name,
                num: matrialArrItem.num,
              }
            }),
            isShrink: false,
          }
        }),
        price: '0',
        isShrink: false,
      }
    })
    detail.value.invoiceInfo = detailData.invoice_info
    detail.value.invoice_apply = detailData.invoice_apply
    invoiceChangeHandle(detailData.invoice_apply)
    isAuthWarehouseOrder.value = isAuthWarehouse(detailData?.order?.repair_warehouse_type)
    Toast.clear()
  } catch (error) {
    commonErrorHandle(error)
  }
  refreshing.value = false
}
async function disAgreeRepairHandle() {
  try {
    await showConfirmModal({
      title: '',
      message: '确认不同意维修方案？',
      className: 'repair-dialog',
    })
  } catch (error) {
    console.log('error', error)
    return
  }
  try {
    showToastLoading()
    await confirmOrderRepair({
      is_agree: 0,
      guid,
    })
    clearToast()
    removeServiceOrderKeepAlive()
    MalfunctionRepairOrderDetailStorage.clear() // 清除缓存
    initPageDetail()
  } catch (error) {
    commonErrorHandle(error)
  }
}
async function confirmRepairHandle() {
  try {
    await showConfirmModal({
      title: '',
      message: '确认维修',
      className: 'repair-dialog',
    })
  } catch (error) {
    console.log('error', error)
    return
  }
  try {
    showToastLoading()
    await confirmOrderRepair({
      is_agree: 1,
      guid,
    })
    clearToast()
    removeServiceOrderKeepAlive()
    removeFaultOrderListItemKeepAlive()
    MalfunctionRepairOrderDetailStorage.clear() // 清除缓存
    initPageDetail()
  } catch (error) {
    commonErrorHandle(error)
  }
}
const onRefresh = () => {
  refreshing.value = true
  initPageDetail(true)
}
onMounted(() => {
  addUpdateMaintainOrderKeepAlive()
  initPageDetail()
  initClipboard('#copyItem')
})

function invoicingHandle() {
  let item = {
    guid,
    ...detail.value.invoiceInfo,
  }
  const cacheKey = CacheSelectRepairOrderInfoKey + item.guid
  sessionStorage.setItem(cacheKey, JSON.stringify(item))
  $router.replace({
    name: 'insurance-repair-invoice-apply',
    query: {
      cacheKey,
      repairType: 'updataMaintenance',
    },
  })
}
onDeactivated(() => {
  clearInterval(timeId)
  clearToast()
  removeUpdateMaintainOrderKeepAlive()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "维修单" }),
    _createVNode(_unref(PullRefresh), {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh,
      class: "detail-wrap"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "status-text",
              style: _normalizeStyle('color:' + _unref(detail)?.color)
            }, _toDisplayString(_unref(detail)?.statusText), 5),
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(detail).sn) + " ", 1),
              _hoisted_4
            ])
          ]),
          _createVNode(BlockWrap, { title: "账单费用" }, {
            default: _withCtx(() => [
              (_unref(isBillEmpty))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detail).billInfo.list, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "price-item van-hairline--bottom",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            (item.package.length > 1)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(["icon-shrink-arrow-right-svg activity-arrow", { 'is-down': !item.isShrink }]),
                                  onClick: ($event: any) => (activityShrinkHandle(item))
                                }, null, 10, _hoisted_11))
                              : _createCommentVNode("", true),
                            _createTextVNode(_toDisplayString(item.activity), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", null, _toDisplayString(`${item.package[0].name} | ￥${item.package[0].price}`), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.package.slice(1), (packageItem, index) => {
                            return _withDirectives((_openBlock(), _createElementBlock("div", {
                              class: "package",
                              key: index
                            }, [
                              _createElementVNode("div", null, _toDisplayString(`${packageItem.name} | ￥${packageItem.price}`), 1)
                            ])), [
                              [_vShow, !item.isShrink]
                            ])
                          }), 128))
                        ]),
                        _hoisted_13
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", null, [
                        _createTextVNode(" 服务费用合计:"),
                        _createElementVNode("span", _hoisted_15, "￥" + _toDisplayString(_unref(detail).billInfo.sum), 1)
                      ])
                    ])
                  ]))
            ]),
            _: 1
          }),
          (_unref(canPay) && !isAuthWarehouseOrder.value)
            ? (_openBlock(), _createBlock(OrderInoviceApply, {
                key: 0,
                invoiceData: _unref(detail)?.invoice_apply || null,
                onInit: _unref(invoiceDomInit)
              }, null, 8, ["invoiceData", "onInit"]))
            : _createCommentVNode("", true),
          (_unref(isBillEmpty))
            ? (_openBlock(), _createBlock(BlockWrap, {
                key: 1,
                class: "service-item",
                title: "服务项目"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detail).billInfo.list.slice(0, 1), (item, index) => {
                  return (_openBlock(), _createBlock(BlockWrap, {
                    title: item.activity,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.package, (packageItem, packageIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "package-item van-hairline--top",
                            key: packageIndex
                          }, [
                            _createElementVNode("div", _hoisted_20, [
                              (packageItem.matrialArr.length > 1)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["icon-shrink-arrow-right-svg package-arrow", { 'is-down': !packageItem.isShrink }]),
                                    onClick: ($event: any) => (packageItemShrinkHandle(packageItem))
                                  }, null, 10, _hoisted_21))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", null, _toDisplayString(`${packageItem.name} | ￥${packageItem.price}`), 1)
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageItem.matrialArr.slice(0, 1), (matrialItem, matrialItemIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "material-list-item",
                                  key: matrialItemIndex
                                }, [
                                  _createElementVNode("div", _hoisted_23, _toDisplayString(matrialItem.name), 1),
                                  _createElementVNode("div", _hoisted_24, "x " + _toDisplayString(matrialItem.num), 1)
                                ]))
                              }), 128)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageItem.matrialArr.slice(1), (matrialItem, matrialItemIndex) => {
                                return _withDirectives((_openBlock(), _createElementBlock("div", {
                                  class: "material-list-item",
                                  key: matrialItemIndex
                                }, [
                                  _createElementVNode("div", _hoisted_25, _toDisplayString(matrialItem.name), 1),
                                  _createElementVNode("div", _hoisted_26, "x " + _toDisplayString(matrialItem.num), 1)
                                ])), [
                                  [_vShow, !packageItem.isShrink]
                                ])
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["title"]))
                }), 128)),
                (!isShrink.value)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(detail).billInfo.list.slice(1), (item, index) => {
                      return (_openBlock(), _createBlock(BlockWrap, {
                        class: "block-wrap-item",
                        title: item.activity,
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.package, (packageItem, packageIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "package-item van-hairline--top",
                                key: packageIndex
                              }, [
                                _createElementVNode("div", _hoisted_28, [
                                  (packageItem.matrialArr.length > 1)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["icon-shrink-arrow-right-svg package-arrow", { 'is-down': !packageItem.isShrink }]),
                                        onClick: ($event: any) => (packageItemShrinkHandle(packageItem))
                                      }, null, 10, _hoisted_29))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", null, _toDisplayString(`${packageItem.name} | ￥${packageItem.price}`), 1)
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageItem.matrialArr.slice(0, 1), (matrialItem, matrialItemIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "material-list-item",
                                      key: matrialItemIndex
                                    }, [
                                      _createElementVNode("div", _hoisted_31, _toDisplayString(matrialItem.name), 1),
                                      _createElementVNode("div", _hoisted_32, "x " + _toDisplayString(matrialItem.num), 1)
                                    ]))
                                  }), 128)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packageItem.matrialArr.slice(1), (matrialItem, matrialItemIndex) => {
                                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                                      class: "material-list-item",
                                      key: matrialItemIndex
                                    }, [
                                      _createElementVNode("div", _hoisted_33, _toDisplayString(matrialItem.name), 1),
                                      _createElementVNode("div", _hoisted_34, "x " + _toDisplayString(matrialItem.num), 1)
                                    ])), [
                                      [_vShow, !packageItem.isShrink]
                                    ])
                                  }), 128))
                                ])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 2
                      }, 1032, ["title"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ])),
          (isAuthWarehouseOrder.value && !_unref(showFooter))
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(authWarehouseMessage)))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(BehalfPay, {
      show: behalfPayDialogVisible.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((behalfPayDialogVisible).value = $event)),
      orderNo: confirmPayInfo.value?.pay_order_no || '',
      behalfStatusCheckHandle: behalfStatusCheckHandle.value,
      onPaySuccess: behalfPaySuccessHandle
    }, null, 8, ["show", "orderNo", "behalfStatusCheckHandle"]),
    (_unref(showFooter))
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          (isAuthWarehouseOrder.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(authWarehouseMessage)))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_38, [
            (_unref(canConfirmRepair))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_unref(Button), {
                    square: "",
                    type: "success",
                    class: "xa-vant-button-cancel btn-cancel",
                    onClick: disAgreeRepairHandle
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 不同意维修方案 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    square: "",
                    type: "success",
                    class: "xa-vant-button",
                    onClick: confirmRepairHandle
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("确认维修")
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            (_unref(canPay))
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  (!isAuthWarehouseOrder.value)
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        square: "",
                        class: "xa-vant-button pay-behalf",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (beforePayHandle('behalf')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("找人代付")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(Button), {
                    square: "",
                    type: "success",
                    class: "xa-vant-button pay-self",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (beforePayHandle('half')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("确认支付")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_unref(canInvoice))
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 2,
                  plain: "",
                  type: "success",
                  class: "invoice-button",
                  onClick: invoicingHandle
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("申请开票")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_40
  ], 64))
}
}

})